// Detect hostname of current environment
const hostname = window.location.hostname;

// Detect protocol (http / https)
const protocol = window.location.protocol;

// Default API for localhost
let API_BASE = `${protocol}//${hostname}:8000`;

// If NOT localhost → production environment
if (hostname !== "localhost") {
    // If frontend is on domain.com or subdomain.domain.com
    // Example frontend: app.mydomain.com
    // API will become: api.mydomain.com

    API_BASE = "https://beta.dialnepal.com.np";
}

export default API_BASE;
